// drawLines.js
export const drawLines = (ctx, lines) => {
    lines.forEach(({ from, to, color }) => {
      // Check if the color is green and make it brighter
      const adjustedColor = color === 'green' ? '#00FF00' : color; // '#00FF00' is a brighter green
  
      ctx.beginPath();
      ctx.moveTo(from[0], from[1]);
      ctx.lineTo(to[0], to[1]);
      ctx.strokeStyle = adjustedColor;
      ctx.lineWidth = 3;
      ctx.stroke();
    });
  };